import { useTranslation } from '@pancakeswap/localization'
import { Button, Flex, Text, useMatchBreakpoints } from '@pancakeswap/uikit'
import { NextLinkFromReactRouter } from '@pancakeswap/widgets-internal'

import ConnectWalletButton from 'components/ConnectWalletButton'
import useTheme from 'hooks/useTheme'
import { styled, keyframes } from 'styled-components'
import { useAccount } from 'wagmi'

const StyledText = styled(Text)`
  font-size: 26px;
  ${({ theme }) => theme.mediaQueries.sm} {
    font-size: 32px;
  }
  ${({ theme }) => theme.mediaQueries.md} {
    font-size: 40px;
  }
  ${({ theme }) => theme.mediaQueries.lg} {
    font-size: 64px;
  }
  ${({ theme }) => theme.mediaQueries.xxl} {
    font-size: 88px;
  }
`

const float = keyframes`
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-10px); }
`

const blink = keyframes`
  0%, 90%, 100% { transform: scaleY(1); }
  95% { transform: scaleY(0.1); }
`

const smileBreath = keyframes`
  0%, 100% { transform: translateX(-50%) scale(1); }
  50% { transform: translateX(-50%) scale(1.08); }
`

const BigSmileyWrap = styled.div`
  position: relative;
  width: 80px;
  height: 80px;
  border-radius: 999px;
  background: linear-gradient(145deg, #25cba8, #17b28e);
  box-shadow: 0 8px 32px rgba(31, 180, 148, 0.34);
  flex-shrink: 0;
  overflow: hidden;
  animation: ${float} 3s ease-in-out infinite;

  ${({ theme }) => theme.mediaQueries.sm} {
    width: 110px;
    height: 110px;
  }

  ${({ theme }) => theme.mediaQueries.md} {
    width: 150px;
    height: 150px;
  }
`

const BigSmileyEye = styled.div`
  position: absolute;
  top: 28%;
  width: 12%;
  height: 18%;
  background: #fff;
  border-radius: 999px;
  animation: ${blink} 4s infinite;
  transform-origin: center;

  &.left {
    left: 28%;
  }
  &.right {
    right: 28%;
  }
`

const BigSmileyMouth = styled.div`
  position: absolute;
  left: 50%;
  bottom: 26%;
  width: 44%;
  height: 18%;
  border: 4px solid #fff;
  border-top: 0;
  border-radius: 0 0 999px 999px;
  transform: translateX(-50%);
  animation: ${smileBreath} 3s ease-in-out infinite;

  ${({ theme }) => theme.mediaQueries.sm} {
    border-width: 5px;
  }
`

const Hero = () => {
  const { t } = useTranslation()
  const { address: account } = useAccount()
  const { theme } = useTheme()
  const { isMobile, isXs, isMd } = useMatchBreakpoints()

  return (
    <Flex
      position="relative"
      flexDirection={['column', null, null, 'row']}
      alignItems={['center', null, null, 'center']}
      justifyContent="center"
      mt={['24px', null, 0]}
      pl={['0px', '0px', '0px', '30px']}
      id="homepage-hero"
    >
      <Flex justifyContent="center" mb={['24px', null, null, '0']} mr={[0, null, null, '32px']}>
        <BigSmileyWrap>
          <BigSmileyEye className="left" />
          <BigSmileyEye className="right" />
          <BigSmileyMouth />
        </BigSmileyWrap>
      </Flex>
      <Flex flex="1" flexDirection="column" alignItems={isMobile || isMd ? 'center' : 'flex-start'}>
        <Text textAlign={isMobile || isMd ? 'center' : 'left'} pr={isMobile ? 0 : '10px'} mb="16px">
          <StyledText display="inline-block" lineHeight="110%" fontWeight={600} color="text" mr="8px">
            {t('Your Crypto,')}
          </StyledText>
          {isMobile && <br />}
          <StyledText display="inline-block" fontWeight={600} lineHeight="110%" color="secondary">
            {t('Your Rules')}
          </StyledText>
        </Text>
        <Text
          mb="24px"
          color={theme.colors.textSubtle}
          maxWidth={600}
          fontSize={['16px', '18px', null, '24px']}
          textAlign={isMobile || isMd ? 'center' : 'left'}
          lineHeight="110%"
          fontWeight={600}
        >
          {t('The friendliest DEX on MA-Chain. Swap tokens instantly with zero hassle and earn')}
        </Text>

        <Flex justifyContent="center">
          {!account && <ConnectWalletButton style={{ borderRadius: isXs ? 12 : undefined }} scale="lg" mr="8px" />}
          <NextLinkFromReactRouter to="/swap">
            <Button scale="lg" style={{ borderRadius: isXs ? 12 : undefined }} variant="primary">
              {t('Swap')}
            </Button>
          </NextLinkFromReactRouter>
        </Flex>
      </Flex>
    </Flex>
  )
}

export default Hero
